module.exports = __webpack_public_path__ + "static/media/camera.f774c10f.png";